const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

/** @type {IntersectionObserver | null} */
let productCardCarouselObserver = null

const ensureObserver = () => {
  if (!('IntersectionObserver' in window)) return null

  if (!productCardCarouselObserver) {
    productCardCarouselObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const el = entry.target

          if (!(el instanceof HTMLElement)) return
          if (typeof el.initCarousel !== 'function') return

          const panel =
            el.closest('[data-product-carousel-tabs-el="panel"]') ||
            el.closest('.sec-ProductCarousel_Panel')

          if (panel && panel.getAttribute('aria-hidden') === 'true') {
            if (!el._productCardPanelObserver) {
              const mutationObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  if (
                    mutation.type === 'attributes' &&
                    mutation.attributeName === 'aria-hidden' &&
                    panel.getAttribute('aria-hidden') === 'false'
                  ) {
                    el.initCarousel()
                    observer.unobserve(el)
                    mutationObserver.disconnect()
                    el._productCardPanelObserver = null
                  }
                })
              })

              mutationObserver.observe(panel, {
                attributes: true,
                attributeFilter: ['aria-hidden'],
              })

              el._productCardPanelObserver = mutationObserver
            }

            return
          }

          el.initCarousel()
          observer.unobserve(el)
        })
      },
      {
        root: null,
        rootMargin: '200px 0px',
        threshold: 0.01,
      },
    )
  }

  return productCardCarouselObserver
}

class ProductCardCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const observer = ensureObserver()

    if (observer) {
      observer.observe(this)
    } else {
      this.initCarousel()
    }

    this.onLayoutSwitchChanged = this.onLayoutSwitchChanged.bind(this)
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.LAYOUT_SWITCH.CHANGED,
      this.onLayoutSwitchChanged,
    )
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (productCardCarouselObserver) {
      productCardCarouselObserver.unobserve(this)
    }

    if (this._productCardPanelObserver) {
      this._productCardPanelObserver.disconnect()
      this._productCardPanelObserver = null
    }

    window.BAO.eventBus.removeEventListener(
      window.BAO.EVENTS.LAYOUT_SWITCH.CHANGED,
      this.onLayoutSwitchChanged,
    )
  }

  initCarousel () {
    if (this.carousel) return
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 901px)': {
            disabled: true,
          },
        },
      },
      [setInitialised()],
    )
  }

  onLayoutSwitchChanged ({ detail }) {
    if (!detail?.grid || !detail.grid.contains(this)) return
    if (this.isInHiddenPanel()) return

    window.requestAnimationFrame(() => {
      if (this.carousel) {
        this.carousel.update()

        return
      }

      this.initCarousel()
    })
  }

  isInHiddenPanel () {
    const panel =
      this.closest('[data-product-carousel-tabs-el="panel"]') ||
      this.closest('.sec-ProductCarousel_Panel')

    return !!panel && panel.getAttribute('aria-hidden') === 'true'
  }
}

if (!customElements.get('product-card-carousel')) {
  customElements.define('product-card-carousel', ProductCardCarousel)
}
